import { render, staticRenderFns } from "./AlipayCallback.vue?vue&type=template&id=9ae605de&scoped=true&"
import script from "./AlipayCallback.vue?vue&type=script&lang=js&"
export * from "./AlipayCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae605de",
  null
  
)

export default component.exports